const OPTIONS = {
  enableHighAccuracy: true,
  maximumAge: 0,
};

export const getGPSRead = () =>
  new Promise((resolve, reject) => {
    const success = ({ coords }) => {
      resolve({
        latitude: coords.latitude,
        longitude: coords.longitude,
        accuracy: coords.accuracy,
      });
      return;
    };

    const error = (err) => {
      reject(err);
      return;
    };

    navigator.geolocation.getCurrentPosition(success, error, OPTIONS);
  });
